import React from 'react'
import styled from 'styled-components'

const StyledContainer = styled.div`
  width: 1424px;
  margin: 0 auto;
  padding: 0 16px;
`

export const MyContainer: React.FC<{
  style?: React.CSSProperties
  className?: string
  children: React.ReactNode
}> = ({ children, style, className }) => {
  return (
    <StyledContainer style={style} className={className}>
      {children}
    </StyledContainer>
  )
}
